<template>
  <section>
    <div class="primary-header">
      <h1 data-qa="Content-Notifications-Title">
        {{ componentTitle }}
        <small>{{ $route.meta.description }}</small>
      </h1>
      <div class="create-new-block" v-if="!noQuotaBlockShows">
        <span
          :class="{ alert: isRulesLimitReached }"
          class="limitation"
          data-qa="Content-LimitationNotifacations-Text">
          {{ $t('notificationsLimitationText', { ownRules, limitRules }) }}
        </span>
        <el-button
          @click="showAddNotification"
          data-qa="Content-AddNotification-Button"
          id="btn-notification-form"
          type="warning"
          v-if="canAddNotification"
        >
          {{ $t('notificationsButtonAddNotificationText') }}
        </el-button>
      </div>
    </div>
    <el-table
      :data="notificationsList"
      :default-sort="defaultSort"
      :element-loading-text="$t('notificationsTableLoadingText')"
      :empty-text="$t('notificationsTableEmptyText')"
      class="notifications-table"
      data-qa="Content-Notifications-Table"
      element-loading-background="#FFFFFF"
      fit
      header-row-class-name="notifications-table__header"
      max-height="100%"
      show-header
      v-if="!noQuotaBlockShows"
      v-loading="loading"
    >
      <el-table-column :label="$t('notificationsTableColRuleLabel')" prop="rule" sortable  min-width="90"></el-table-column>
      <el-table-column :label="$t('notificationsTableColInfoModelLabel')" sortable  min-width="100">
        <template slot-scope="props">
          <span class="word-break">{{ props.row.familyNames }}</span>
        </template>
      </el-table-column>
      <el-table-column  :label="$t('notificationsTableColTitleLabel')" min-width="180">
        <template slot-scope="props">
          <span class="word-break">{{ props.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column  :label="$t('notificationsTableColMessageLabel')" min-width="240">
        <template slot-scope="props">
          <span class="word-break">{{ props.row.message }}</span>
        </template>
      </el-table-column>
      <el-table-column label="" fixed="right" min-width="60">
        <template slot-scope="scope">
          <el-tooltip :content="$t('notificationsTooltipEditText')" effect="dark" placement="top-start">
            <el-button
              :data-qa="`Content-EditNotification-Button-${scope.row.title}`"
              @click="editNotification(scope.row.id)"
              type="text"
              size="mini"
            >
              <i class="fa fa-pencil operation-icons"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip :content="$t('notificationsTooltipDeleteText')" effect="dark" placement="top-start">
            <el-button
              :data-qa="`Content-DeleteNotification-Button-${scope.row.title}`"
              @click="delNotification(scope.row.id)"
              type="text"
              size="mini"
            >
              <i class="fa fa-trash operation-icons"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="notify-limited-block"
      data-qa="Content-LimitedBlockNotifications-Text"
      v-else>
      <span class="title">
        {{ $t('NotificationsLimitedBlockNotificationsTitle') }}
      </span>
      <i18n path="NotificationsLimitedBlockNotificationsBody" tag="p">
        <br place="br" />
        <p place="p" />
        <a href="mailto:support@exosite.com" place="support">{{ $t('solutionStatusTestDialogSupport') }}</a>
      </i18n>
    </div>
    <notifications-edit :familyMembers="familyMembers" :familyNames="familyNames" :uid="uid"></notifications-edit>
    <notifications-delete></notifications-delete>
    <notifications-create :familyMembers="familyMembers" :familyNames="familyNames" :noQuota="isRulesLimitReached" :uid="uid"></notifications-create>
  </section>
</template>

<script>
  import main from './Notifications.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './Notifications.scss'
</style>



// WEBPACK FOOTER //
// Notifications.vue?226a8abc